import { useRef } from 'react'
import { useAppSelector } from '@app/model/store/client'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { MediaCard } from '@shared/ui/Layout/Cards/MediaCard'
import type { TypeNewsCardData } from '@shared/api/middleware/mappingAPI/news/viewModel'
import { EGG } from '@shared/api/analytics'
import { useIntersectionAnalytic } from '@shared/lib/hooks/useIntersectionAnalytic'
import { useClientReady } from '@shared/lib/hooks/useClientReady'
import { PickAnalytic } from '@shared/api/analytics/types/types'

// 1x1, 2x1 for mobile
// type size = 'L1x1 L2x1 M1x1 M2x1 S1x1 1x1 2x1'
interface NewsCardProps {
  data: TypeNewsCardData
  className?: string
  sizes: string
  analytic: PickAnalytic<'section_index' | 'section_name'>
  deferImage?: boolean
}

function NewsCard({ data, className = '', analytic, sizes, deferImage = false }: NewsCardProps) {
  const storeCurrentCitySlug = useAppSelector((state) => state.global.currentCity?.slug) ?? 'msk'
  const cardRef = useRef<HTMLDivElement | null>(null)
  const imagesReady = useClientReady()

  const handleClick = () => EGG.entity.news.card_click(data, analytic)
  useIntersectionAnalytic(cardRef, () => EGG.entity.news.card_view(data, analytic))

  return (
    <BlockBoundary>
      <MediaCard
        id={String(data.id)}
        sizes={sizes}
        favorite={{
          category: 'news',
          analytic: {
            data: data,
            other: {
              section_name: analytic.section_name,
            },
          },
        }}
        title={data.description.title}
        subtitle={{ name: data.type.name, url: `/${storeCurrentCitySlug}/restaurant-news/?variety=${data.type.slug}` }}
        date={data.date}
        img={{
          desktop: {
            horizontal:
              data.img.sizes.cover_1220x594 || data.img.sizes.desktop.default1 || data.img.sizes.desktop['609x303'],
            vertical: data.img.sizes.cover_594x594 || data.img.sizes.desktop['303x303'],
          },
          mobile: {
            vertical:
              data.img.sizes.cover_594x594 || data.img.sizes.desktop['303x303'] || data.img.sizes.mobile['224x168'],
          },
        }}
        url={data.url.path}
        promo={data.categories.advert}
        className={className}
        hideImage={deferImage && !imagesReady}
        onClick={handleClick}
        ref={cardRef}
      />
    </BlockBoundary>
  )
}

export default NewsCard
